import { render, staticRenderFns } from "./CamposEmenta.vue?vue&type=template&id=fe975d88&scoped=true"
import script from "./CamposEmenta.vue?vue&type=script&lang=ts&setup=true"
export * from "./CamposEmenta.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./CamposEmenta.vue?vue&type=style&index=0&id=fe975d88&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe975d88",
  null
  
)

export default component.exports